<template>
  <ul class="history-list-container-mobile">
    <li v-for="(item, key) in record" :key="key" class="board goTo-data-popup" @click="showHistoryModal(item)">
      <div class="con-box">
        <div class="fs-14px">
          {{ $t("Bao.status") }}
        </div>
        <div class="con-date">
          <div class="state-box">
            <span class="fs-14px fw-700">{{ item.status_label }}</span>
          </div>
        </div>
      </div>

      <div class="con-box">
        <div class="fs-14px">
          {{ $t("Bao.time") }}
        </div>
        <div class="con-date fs-14-w-700">
          {{ item.formattedTime }}
        </div>
      </div>

      <div class="con-box">
        <div class="fs-14px">
          {{ $t("Bao.withdrawal_for_record") }}
        </div>
        <div class="con-date">
          <div class="amount-container">
            <div class="amount-box">
              <span class="fs-14px fw-700">{{ item.amount | numberFormat }}</span>
              <img class="his-icon" :src="item.image">
            </div><i class="fa-solid fa-angle-right" aria-hidden="true" />
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'WithdrawalHistoryMobile',
  props: {
    record: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {

    }
  },
  created() {

  },
  methods: {
    showHistoryModal(item) {
      this.$emit('show-history-modal', item)
    }
  }
}
</script>
